// extracted by mini-css-extract-plugin
export var arrow = "Properties-module--arrow--c9ec7";
export var button = "Properties-module--button--cf66e";
export var cardCarousel = "Properties-module--cardCarousel--fd9a6";
export var container = "Properties-module--container--1179f";
export var decor = "Properties-module--decor--b5701";
export var full = "Properties-module--full--da9af";
export var gLogo = "Properties-module--gLogo--8f08d";
export var imageCarousel = "Properties-module--imageCarousel--f77a6";
export var infoBlock = "Properties-module--infoBlock--6f731";
export var infoBox = "Properties-module--infoBox--b785a";
export var item = "Properties-module--item--e8879";
export var lineAbove = "Properties-module--lineAbove--25e69";
export var navigation = "Properties-module--navigation--84feb";
export var next = "Properties-module--next--f664c";
export var position = "Properties-module--position--891f2";
export var prev = "Properties-module--prev--e5dd4";
export var propertyCard = "Properties-module--propertyCard--5399c";
export var relativeWrapper = "Properties-module--relativeWrapper--b8b75";
export var slideImage = "Properties-module--slideImage--72ae4";
export var small = "Properties-module--small--887d3";